import { styled } from '@material-ui/core';
import BackgroundPaper from '../BackgroundPaper';

export const RootComponent = styled(BackgroundPaper)(
  ({ collapsible, isOpen }) => ({
    padding: '20px 30px',
    height: collapsible && !isOpen ? 'auto' : '100%',
  })
);

export const HeaderContainer = styled('div')(({ collapsible, isOpen }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: collapsible && !isOpen ? '0' : '20px',
  cursor: collapsible ? 'pointer' : 'auto',
}));

export const TitleContainer = styled('div')(({ theme }) => ({
  color: theme.palette.common.black,
  fontWeight: 'bold',
  fontSize: '20px',
  lineHeight: '28px',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'left',
}));

export const ButtonContainer = styled('div')({
  textAlign: 'right',
});

export const CollapsibleButtonContainer = styled('div')(({ theme }) => ({
  color: theme.palette.xpl.action.primary,
  textAlign: 'right',
}));

export const BodyContainer = styled('div')({});
